import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'faire_direct-faire_direct_landing_page_sign_up-click';
/**
 * Click event for the sign up button in the why faire section of the FD landing page
 */
export function trackFaireDirectFaireDirectLandingPageSignUpClick(pageSection) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { pageSection },
    });
}
